import React from "react";
import PropTypes from "prop-types";

import StandardMenuPages from "./StandardMenuPages";
import ComponentMissing from "../../Debug/ComponentMissing";

const MenuPagesSwitcher = ({
  properties: {
    layout,
    primaryLink,
    primaryLinkType,
    secondaryLink,
    secondaryLinkType,
    logo,
    topLinks,
    navigation,
    languages,
    activeLanguage,
  },
}) => {
  const properties = {
    primaryLink,
    primaryLinkType,
    secondaryLink,
    secondaryLinkType,
    logo,
    topLinks,
    navigation,
    languages,
    activeLanguage,
  };

  function switchMenuPages() {
    switch (layout) {
      case "standard":
        return <StandardMenuPages properties={properties} />;
      default:
        return <ComponentMissing type="MenuPages" subType={layout} />;
    }
  }

  return switchMenuPages();
};

MenuPagesSwitcher.propTypes = {
  properties: PropTypes.instanceOf(Object),
};

export default MenuPagesSwitcher;
